import { render, staticRenderFns } from "./TaxInvoiceSerialNumber.vue?vue&type=template&id=014b547d&"
import script from "./TaxInvoiceSerialNumber.vue?vue&type=script&lang=ts&"
export * from "./TaxInvoiceSerialNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('014b547d')) {
      api.createRecord('014b547d', component.options)
    } else {
      api.reload('014b547d', component.options)
    }
    module.hot.accept("./TaxInvoiceSerialNumber.vue?vue&type=template&id=014b547d&", function () {
      api.rerender('014b547d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/taxinvoiceserialnumber/TaxInvoiceSerialNumber.vue"
export default component.exports